import moment from 'moment'

/**
 * Calculate a datetime relative to today's elapsed time as a percentage number - rounded to max. two decimals.
 *
 * @param {moment.MomentInput} dateTime Date or valid ISO string/number that should be converted
 * @param {moment.MomentInput} [day] The day to which the percentage figure should refer
 * @returns {number}
 */
export function toDaysElapsedTimeInPercentage(dateTime, day = moment()) {
    const castedDateTime = moment(dateTime)
    const castedDay = moment(day)
    const startOfDay = castedDay.startOf('day').valueOf()
    const endOfDay = castedDay.endOf('day').valueOf()

    const percentage = ((castedDateTime.valueOf() - startOfDay) / (endOfDay - startOfDay)) * 100
    const percentageReducedToToday = Math.min(Math.max(percentage, 0), 100)

    return Number(percentageReducedToToday.toFixed(2))
}
